
import { useState } from 'react';
import { hideTechnique, unhideTechnique } from '@/services';

export const useTechniqueVisibility = (
  techniqueId: string, 
  initialIsHidden: boolean = false
) => {
  const [isHidden, setIsHidden] = useState<boolean>(initialIsHidden);
  const [isHiding, setIsHiding] = useState<boolean>(false);

  const handleHideToggle = async (
    e: React.MouseEvent, 
    customHideToggleHandler?: (e: React.MouseEvent) => void
  ) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // If a custom handler is provided, call it and return
    if (customHideToggleHandler) {
      customHideToggleHandler(e);
      return;
    }

    // Skip if already processing
    if (isHiding) return;

    setIsHiding(true);

    try {
      if (isHidden) {
        await unhideTechnique(techniqueId);
        setIsHidden(false);
      } else {
        await hideTechnique(techniqueId);
        setIsHidden(true);
      }
    } catch (error) {
      console.error('Error toggling hidden state:', error);
    } finally {
      setIsHiding(false);
    }
  };

  return {
    isHidden,
    isHiding,
    handleHideToggle
  };
};
